module.exports = function getResource(label, vars = []) {
    let resources = {
        post: 'publication',
        posts: 'publications',
        group: 'groupe',
        groups: 'groupes',
        photo: 'photo',
        photos: 'photos',
        review: 'commentaire',
        reviews: 'commentaires'
    };
    return resources[label];
};
